module.exports = __webpack_public_path__ + "img/sub_hed.7a37003c.svg";